import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  IReqLivenessCheckResolve,
  IResKycVerified,
  IResKycVerifyUrl,
  IResLivenessCheckResolve,
} from './liveness-check.interface';

@Injectable({
  providedIn: 'root',
})
export class LivenessCheckService {
  private readonly resolveUrl = '/api/v2/livenessCheckConfigurations/resolve';
  private readonly verifyUrlEndpoint = '/api/v2/checkout/kyc/verify-url';
  private readonly kycVerifiedUrl = '/api/v2/checkout/kyc/verified';

  constructor(protected http: HttpClient) {}

  resolve(
    request: IReqLivenessCheckResolve,
  ): Observable<IResLivenessCheckResolve> {
    return this.http.post<IResLivenessCheckResolve>(this.resolveUrl, request);
  }

  getVerifyUrl(): Observable<IResKycVerifyUrl> {
    return this.http.post<IResKycVerifyUrl>(this.verifyUrlEndpoint, {}).pipe(
      map((response) => {
        if (response?.verifyUrl) {
          return response;
        }

        throw new HttpErrorResponse({
          error: response,
          url: this.verifyUrlEndpoint,
        });
      }),
    );
  }

  checkKycVerified(): Observable<IResKycVerified> {
    return this.http.get<IResKycVerified>(this.kycVerifiedUrl);
  }
}
